export const styles = {
  dialogContainer: {
    width: '480px',
    height: '100%',
    outline: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  dialogContent: {
    padding: '0 24px',
  },

  selectedItems: {
    backgroundColor: '#F9FAFB',
    paddingBottom: '16px',
    paddingLeft: '16px',
    marginTop: '16px',
    border: '1px solid',
    borderRadius: '8px',
    borderColor: 'grey.300',
  },

  icon: {
    m: '5px 5px auto auto',
    width: '30px',
    paddingTop: 0,
  },

  imageIcon: {
    width: '24px',
    height: '24px',
  },

  borderLine: {
    borderBottom: '1px solid #D3D3D3',
  },

  disclaimer: {
    fontSize: '11px',
    lineHeight: '18px',
    color: 'text.secondary',
  },

  backButton: {
    icon: {
      width: '18px',
      height: '18px',
    },
    sx: {
      textAlign: 'center',
      color: 'text.primary',
      width: '94px',
      marginTop: '4px',
      border: '1px solid #D3D3D3',
    },
  },
};
